<mat-card class="error-card">
    <mat-card-header>
        <img mat-card-avatar src="/assets/img/robot.png">
        <mat-card-title>Erro</mat-card-title>
        <mat-card-subtitle>Inesperado</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <p>Nenhum chat selecionado. Por favor, entre no link correto do chat.</p>
    </mat-card-content>
</mat-card>